export const pageList = [
  {
    pageKey: "main",
    pageName: "首页",
  },
  {
    pageKey: "deviceList",
    pageName: "设备管理",
  },
  {
    pageKey: "deviceType",
    pageName: "设备型号",
  },
  {
    pageKey: "company",
    pageName: "公司列表",
  },
  {
    pageKey: "platformMenu",
    pageName: "平台菜单",
  },
  {
    pageKey: "companyMenu",
    pageName: "公司菜单",
  },
  {
    pageKey: "personList",
    pageName: "人员管理",
  },
  {
    pageKey: "roleList",
    pageName: "角色管理",
  },
];